import { Button, Typography } from '@mui/material';
import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { LoadingButton } from '@mui/lab';
import { useSnackbar } from 'notistack';
import { ConvertToBase64 } from '../../../../helper/commonHelper';
import { uploadFile } from '../../../../service/upload.file.service';
import PencilIcon from '../../../../svg/PencilIcon';
import Header from '../../../../components/Header';
import FileUploadContainer from '../../../../components/FileUploadContainer';
import DownloadFileContainer from '../../../../components/DownloadFileContainer';
import DeleteIcon from '../../../../svg/DeleteIcon';
import palette from '../../../../theme/palette';
import { submitAssignment } from '../../../../service/assignment.submission.service';

const useStyles = makeStyles({
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 15
  }
});

export default function UploadSolution({ onBack, startDateTime }) {
  const studentData = useSelector((state) => state.auth.currentUser);
  const classes = useStyles();
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInput = useRef(null);
  const [isBtnLoading, setBtnLoading] = useState(false);
  const classData = useSelector((state) => state.classes.selectedClass);
  const { enqueueSnackbar } = useSnackbar();

  const onFileSubmit = async () => {
    setBtnLoading(true);
    const base64 = await ConvertToBase64(selectedFile);
    const fileObj = {
      base64,
      fileType: selectedFile.type,
      fileName: selectedFile.name,
      uploadFor: 'assignmentSubmission',
      userId: studentData.id,
      orgId: classData.orgID
    };
    const fileRes = await uploadFile(classData.id, fileObj);
    if (fileRes) {
      const assignmentObj = {
        orgID: classData.id,
        studentID: studentData.id,
        type: 'upload',
        submittedURL: fileRes.fileURL,
        duration: moment(new Date()).diff(moment(startDateTime), 'minutes')
      };
      submitAssignment(classData.id, assignmentObj)
        .then(() => {
          setBtnLoading(false);
        })
        .catch(() => {
          enqueueSnackbar('Something went wrong please try again', {
            variant: 'error'
          });
          setBtnLoading(false);
        });
    } else {
      enqueueSnackbar('Something went wrong please try again', {
        variant: 'error'
      });
      setBtnLoading(false);
    }
  };

  return (
    <div style={{ marginTop: 20 }}>
      <input
        type="file"
        accept="image/png, image/jpeg, .pdf"
        style={{ display: 'none' }}
        ref={fileInput}
        onChange={() => {
          setSelectedFile(fileInput.current.files[0]);
        }}
      />
      <Header title="Assignment Solution" onBack={onBack} />
      <div style={{ marginTop: 35 }}>
        <Typography variant="subtitle1">Upload Solution</Typography>
        <Typography variant="subtitle2" style={{ marginBottom: 20 }}>
          Select one file at a time.You ca use PDF or image.
        </Typography>
        {selectedFile === null ? (
          <FileUploadContainer onFileChange={(e) => setSelectedFile(e)} />
        ) : (
          <div>
            <DownloadFileContainer title={selectedFile.name} />
            <div className={classes.buttonContainer}>
              <Button onClick={() => fileInput.current.click()}>
                <PencilIcon color={palette.primary.main} style={{ marginRight: 15 }} />
                Edit Solution
              </Button>
              <Button color="error" onClick={() => setSelectedFile(null)}>
                <DeleteIcon color="red" style={{ marginRight: 15 }} />
                Delete Solution
              </Button>
            </div>
            <div style={{ marginTop: 40, display: 'flex', justifyContent: 'center' }}>
              <LoadingButton
                onClick={() => onFileSubmit()}
                loading={isBtnLoading}
                variant="contained"
                style={{ borderRadius: '20px', width: '45%' }}
              >
                Submit
              </LoadingButton>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

UploadSolution.propTypes = {
  onBack: PropTypes.func,
  startDateTime: PropTypes.string
};
